<template>
  <ol-vector-layer zIndex="10" :visible="isVisible">
    <ol-source-vector>
      <ol-feature
        v-for="(sensor, index) in sensorReadings.slice(0, -1)"
        :key="index"
        :properties="{ name: index, type: 'cable' }"
      >
        <ol-geom-line-string
          :coordinates="[
            [sensorReadings[index].coordinate?.easting, sensorReadings[index].coordinate?.northing],
            [
              sensorReadings[index + 1].coordinate?.easting,
              sensorReadings[index + 1].coordinate?.northing
            ]
          ]"
        ></ol-geom-line-string>
        <ol-style>
          <ol-style-stroke :color="strokeColor" :width="strokeWidth"></ol-style-stroke>
        </ol-style>
      </ol-feature>
    </ol-source-vector>
  </ol-vector-layer>
</template>

<script setup lang="ts">
import { MapCableDataPoint } from '@/server/MakeSenseApp-backend'
import { ref, defineProps, PropType } from 'vue'

const strokeWidth = ref(12)
const strokeColor = '#00215F'

defineProps({
  sensorReadings: {
    type: Array as PropType<MapCableDataPoint[]>,
    required: true
  },
  isVisible: {
    type: Boolean,
    required: true
  }
})
</script>

<style scoped></style>
